import Raven from 'raven-js';
import { fetchInteractiveCardInstance } from '../../clients/fetchInteractiveCardInstance';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { getInteractiveCardByInstanceId } from '../selectors/getInteractiveCardByInstanceId';
import { parseCardInstanceResponse } from '../operators/parseCardInstanceResponse';
import { cardResponseReceived } from '../slice/interactiveCardsSlice';
export const refetchCardAfterTimeout = cardInstanceId => async (dispatch, getState) => {
  const state = getState();
  const sessionId = getSessionId(state);
  const card = getInteractiveCardByInstanceId(state, cardInstanceId);
  if (!card) {
    return;
  }
  if (!sessionId) {
    dispatch(cardResponseReceived({
      cardInstanceId,
      errorReason: ''
    }));
    return;
  }
  try {
    const cardInstance = await fetchInteractiveCardInstance({
      cardInstanceId,
      sessionId
    });
    if (cardInstance.version > card.cardInstanceVersion) {
      dispatch(cardResponseReceived(Object.assign({
        cardInstanceId
      }, parseCardInstanceResponse(cardInstance), {
        errorReason: ''
      })));
    } else {
      // Version not ahead of Redux — either unchanged or stale; unblock the UI
      dispatch(cardResponseReceived({
        cardInstanceId,
        errorReason: ''
      }));
    }
  } catch (error) {
    Raven.captureException(error);
    // Unblock the UI even when the fetch fails
    dispatch(cardResponseReceived({
      cardInstanceId,
      errorReason: ''
    }));
  }
};